import moment from 'moment';
export default {
	isMmcAdmin: false,
	maxCnt: 0,
	sumCnt: 0,
	resultList: {},
	graphList: [],
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO(),
	eqipKndCdList: [] //장비종류 selectBox
};

function SEARCH_PARAMS() {
	return {
		strDt: moment().startOf('year').format('YYYYMM'),
		endDt: moment().endOf('year').format('YYYYMM'),
		eqipKndCd: '',
		mesEqipNo:''
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}
export { SEARCH_PARAMS, PAGING_INFO };
